export interface DropdownStyles {
  headerClasses: string;
  labelClasses: string;
  buttonClasses: string;
  previewOptionClasses: string;
  openedListboxClasses: string;
  closedListboxClasses: string;
  primaryOptionClasses: string;
  secondaryOptionClasses: string;
  selectedOptionClasses: string;
  unselectedOptionClasses: string;
}

export const defaultDropdownStyles: DropdownStyles = {
  headerClasses: 'flex items-baseline',
  labelClasses: 'mr-1 text-xs text-midnight font-heading',
  buttonClasses: 'inline-flex items-start',
  previewOptionClasses: 'mb-0 mr-2 sm:mr-3 font-heading',
  openedListboxClasses:
    'block absolute bg-sea-foam z-mid shadow-md mt-4 py-2 rounded-lg outline-hidden focus:ring-1 focus:border-tuna-shade',
  closedListboxClasses: 'hidden',
  primaryOptionClasses:
    'cursor-pointer font-heading transition-colors text-sm whitespace-nowrap py-3 px-8 mb-0 hover:bg-lake-fog hover:text-pinktail',
  secondaryOptionClasses:
    'cursor-pointer font-heading transition-colors text-sm whitespace-nowrap py-3 px-8 mb-0 hover:bg-lake-fog hover:text-pinktail',
  selectedOptionClasses: 'text-pinktail',
  unselectedOptionClasses: 'bg-sea-foam text-trench',
};
